import { FilterOutlined } from '@ant-design/icons';
import {
  Button, Table, Tooltip,
} from 'antd';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import NormalButton from '../../buttons/normalButton';
import SearchBar from '../../searchBar';
import './style.scss';


const NormalTable = (props) => {
  const keySearchRef = useRef();
  const filterRef = useRef();
  const toggleModal = () => {
    props.toggleModal();
  };
  const onCreate = () => {
    props.onCreate();
  };
  const onSearch = (key) => {
    keySearchRef.current = key;
    props.fetchData(keySearchRef.current, filterRef.current);
  };
  const onRowClick = (record, rowIndex) => {
    props.onRowClick(record, rowIndex);
  };
  const onFilter = (filter) => {
    filterRef.current = filter;
    props.toggleModal();
    props.fetchData(keySearchRef.current, filterRef.current);
  };

  const renderSearchArea = () => (
    <div className={classnames('search-area', props.className)}>
      <div className="search">
        { props.isSearch
      && <SearchBar searchBy={props.searchBy} fetchData={onSearch} />
      }

        { props.extra }

        { props.isFilter
      && (
      <Tooltip placement="top">
        <Button
          className="table-wrapper-filter-btn"
          icon={<FilterOutlined />}
          type="primary"
          onClick={toggleModal}
        />
      </Tooltip>
      )
      }
      </div>
      <div className="info">
        { props.isCreate
          && (
          <NormalButton
            className="create-btn"
            text={props.createType}
            icon={props.icon}
            type="primary"
            onClick={onCreate}
          />
          )
        }
      </div>
    </div>
  );

  return (
    <div className={classnames('table-wrapper', props.className)}>
      { (props.isSearch || props.isCreate || props.isFilter) && renderSearchArea()}
      <Table
        dataSource={props.dataSource}
        columns={props.columns}
        pagination={false}
        loading={props.loading}
        scroll={props.scroll}
        locale={props.emptyText ? { emptyText: props.emptyText } : undefined}
        rowClassName={(record) => {

        }}
        onRow={(record, rowIndex) => ({
          onClick: (e) => {
            const cellText = document.getSelection();
            if (cellText.type === 'Range') {
              e.stopPropagation();
            } else {
              onRowClick(record, rowIndex);
            }
          },
        })}
      />
    </div>

  );
};

NormalTable.defaultProps = {
  className: '',
  dataSource: [],
  columns: [],
  scroll: {},
  isSearch: false,
  icon: undefined,
  loading: false,
  searchBy: [],
  isFilter: false,
  isCreate: false,
  filterVisible: false,
  emptyText: undefined,
  extra: null,

  fetchData: () => {},
  toggleModal: () => {},
  onCreate: () => {},
  onRowClick: () => {},
};

NormalTable.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  dataSource: PropTypes.arrayOf(PropTypes.shape()),
  columns: PropTypes.arrayOf(PropTypes.shape()),
  scroll: PropTypes.shape({}),
  isSearch: PropTypes.bool,
  icon: PropTypes.node,
  searchBy: PropTypes.arrayOf(PropTypes.shape()),
  isFilter: PropTypes.bool,
  isCreate: PropTypes.bool,
  createType: PropTypes.string,
  filterVisible: PropTypes.bool,
  emptyText: PropTypes.node,
  extra: PropTypes.node,

  fetchData: PropTypes.func,
  toggleModal: PropTypes.func,
  onCreate: PropTypes.func,
  onRowClick: PropTypes.func,
};

export default NormalTable;
